export default "__VITE_ASSET__bfe341e1__"